import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
    Container,
    Card,
    Table,
    Badge,
    Spinner,
    Form,
    Button,
    Modal,
} from "react-bootstrap";
import Swal from "sweetalert2";

import {API_BASE} from "../../services/apirest";
import { invalidateSolicitudesCache } from "../../services/solicitudesCache";
import InformacionUsuario from "../modales/InformacionUsuario";
import AvatarCentrado from "../modales/AvatarCentrado";
import FotoINE from "../modales/FotoINE";


export default function SolicitudReactivar() {
    const [list, setList] = useState(null);
    const [selected, setSelected] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);

    const [filterStatus, setFilterStatus] = useState("React. Solicitada");

    const [showSiebelModal, setShowSiebelModal] = useState(false);
    const [siebelValue, setSiebelValue] = useState("");
    const [showToaModal, setShowToaModal] = useState(false);
    const [toaValue, setToaValue]       = useState("");
    const [showUserRedModal, setShowUserRedModal] = useState(false);
    const [userRedValue, setUserRedValue] = useState("");
    const [reactivarLoadingId, setReactivarLoadingId] = useState(null);
    const headers = useMemo(
        () => ({
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        }),
        []
    );
    const triggerGlobalRefresh = useCallback(() => {
        invalidateSolicitudesCache(key => key.includes('/solicitudes.php'));
        if (typeof window !== 'undefined') {
            window.dispatchEvent(new Event('solicitudes:refresh'));
            window.dispatchEvent(new Event('inbox:refresh'));
        }
    }, []);

    const load = useCallback(async () => {
        try {
            const res = await fetch(`${API_BASE}/solicitudes.php?reactivacion_stage=SolicitudReactivacion`, { headers });
            const data = await res.json();
            const arr = (data.result?.solicitudes || [])
                .sort((a,b) => new Date(b.Fecha) - new Date(a.Fecha));
            setList(arr);
        } catch (e) {
            console.error(e);
            setList([]);
        }
    }, [headers]);

// Lista ordenada (ya no uses filteredList/filteredList2)
    const sortedList = useMemo(
        () => [...(list || [])].sort((a,b) => new Date(b.Fecha) - new Date(a.Fecha)),
        [list]
    );


    useEffect(() => {
        load();
        const poll = setInterval(load, 30000);
        return () => clearInterval(poll);
    }, [load]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const needsTelco = (s) => s.red_siebel_telcom == null || s.red_siebel_telcom === "";
    const needsRed   = (s) => s.usuario_red == null || s.usuario_red === "";
    const needsToa   = (s) => s.rol_id === 9 && (s.fgu_toa == null || s.fgu_toa === "");

    const listoParaReactivar = (s) =>
        s.reactivacion_stage === "SolicitudReactivacion" &&
        !needsTelco(s) && !needsRed(s) && !needsToa(s);

    if (list === null) {
        return (
            <Container
                className="d-flex justify-content-center align-items-center"
                style={{ height: "60vh" }}
            >
                <Spinner animation="border" />
            </Container>
        );
    }

    return (
        <div className="app-container">
            <Container className="my-5">
                <div className="d-flex align-items-end mb-3">
                    <Form.Group
                        controlId="statusFilter"
                        className="me-3 mb-0"
                        style={{ minWidth: "200px" }}
                    >
                        <Form.Label>Filtrar por Estado:</Form.Label>
                        <Form.Select
                            value={filterStatus}
                            onChange={(e) => setFilterStatus(e.target.value)}
                        >
                            <option value="Pendiente de validación">En proceso</option>
                            <option value="Pendiente revisión">Validado</option>
                            <option value="Creacion FGU">FGU</option>
                        </Form.Select>
                    </Form.Group>
                </div>

                <Card className="shadow-sm">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5>Solicitudes de reactivación</h5>
                        <Badge bg={list.length > 0 ? "info" : "secondary"} pill>
                            {list.length}
                        </Badge>
                    </Card.Header>
                    <Card.Body>
                        {list.length === 0 ? (
                            <p className="text-center text-muted">No hay registros con ese estado.</p>
                        ) : (
                            <Table responsive hover striped className="mb-0 align-middle">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>RFC</th>
                                    <th>Teléfono</th>
                                    <th>Usuario de red</th>
                                    <th>CVV</th>
                                    <th>Fecha</th>
                                    <th className="text-center">Acción</th>
                                </tr>
                                </thead>
                                <tbody>
                                {sortedList.map((s) => (
                                    <tr
                                        key={s.SolicitudId}
                                    >
                                        <td
                                          style={{ cursor: "pointer", color: "#0056b3", textDecoration: "underline" }}
                                          onClick={() => {
                                            setSelected(s);
                                            setShowDetailModal(true);
                                          }}
                                        >
                                          {s.nombre_usuario} {s.apellido_paterno} {s.apellido_materno}
                                        </td>
                                        <td>{s.rfc}</td>
                                        <td>{s.telefono}</td>
                                        <td>{s.usuario_red}</td>
                                        <td>{s.numero_vendedor}</td>
                                        <td>{new Date(s.Fecha).toLocaleDateString()}</td>
                                        <td className="text-center">
                                            {s.reactivacion_stage === "SolicitudReactivacion" && needsTelco(s) && (
                                                <Button
                                                    variant="info" size="sm" className="me-1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelected(s);
                                                        setSiebelValue(s.red_siebel_telcom || "");
                                                        setShowSiebelModal(true);
                                                    }}
                                                >
                                                    SIEBEL TELCO
                                                </Button>
                                            )}

                                            {s.reactivacion_stage === "SolicitudReactivacion" && needsToa(s) && (
                                                <Button
                                                    variant="secondary" size="sm" className="me-1"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelected(s);
                                                        setToaValue(s.fgu_toa || "");
                                                        setShowToaModal(true);
                                                    }}
                                                >
                                                    TOA
                                                </Button>
                                            )}

                                            {s.reactivacion_stage === "SolicitudReactivacion" && needsRed(s) && (
                                                <Button
                                                    variant="primary" size="sm"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelected(s);
                                                        setUserRedValue(s.usuario_red || "");
                                                        setShowUserRedModal(true);
                                                    }}
                                                >
                                                    USUARIO RED
                                                </Button>
                                            )}

                                           {listoParaReactivar(s) && (
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    disabled={reactivarLoadingId === s.SolicitudId}
                                                    onClick={async () => {
                                                    setReactivarLoadingId(s.SolicitudId);
                                                    try {
                                                        const res = await fetch(`${API_BASE}/solicitudes.php`, {
                                                        method: "PUT",
                                                        headers,
                                                        body: JSON.stringify({
                                                            action: "aprobar_reactivacion",
                                                            SolicitudId: s.SolicitudId,
                                                            reactivacion_stage: "Ejecutado",
                                                            Estado: "Pendiente",
                                                        }),
                                                        });
                                                        const d = await res.json();
                                                        if (d.status === "success" || d.status === "ok") {
                                                        Swal.fire("Listo", "Reactivado.", "success");
                                                        setList(prev =>
                                                            prev.map(x =>
                                                            x.SolicitudId === s.SolicitudId
                                                                ? { ...x, reactivacion_stage: "Ejecutada", Estado: "Pendiente", status: "Activo" }
                                                                : x
                                                            )
                                                        );
                                                        triggerGlobalRefresh();
                                                        } else {
                                                        Swal.fire("Error", d.result?.error_msg || "No se pudo reactivar", "error");
                                                        }
                                                    } catch (err) {
                                                        console.error(err);
                                                        Swal.fire("Error", "No se pudo conectar al servidor", "error");
                                                    } finally {
                                                        setReactivarLoadingId(null);
                                                    }
                                                    }}
                                                >
                                                    {reactivarLoadingId === s.SolicitudId ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        Reactivando...
                                                    </>
                                                    ) : (
                                                    "Reactivar"
                                                    )}
                                                </Button>
                                                )}

                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        )}
                    </Card.Body>
                </Card>

                <Modal show={showSiebelModal} onHide={() => setShowSiebelModal(false)} centered>
                    <Modal.Header closeButton><Modal.Title>INGRESAR FGU SIEBEL TELCO</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>REACTIVACIÓN FGU SIEBEL TELCO</Form.Label>
                            <Form.Control
                                type="text"
                                value={siebelValue}
                                onChange={(e) => setSiebelValue(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowSiebelModal(false)}>Cancelar</Button>
                        <Button variant="primary" onClick={async () => {
                            if (!siebelValue.trim()) {
                                Swal.fire("Error", "Debes ingresar el valor de Siebel Telco", "warning");
                                return;
                            }
                            const payload = { SolicitudId: selected.SolicitudId, red_siebel_telcom: siebelValue.trim() };
                            const res = await fetch(`${API_BASE}/solicitudes.php`, {
                                method: "PUT",
                                headers,
                                body: JSON.stringify(payload),
                            });
                            const data = await res.json();
                            if (data.status === "success" || data.status === "ok") {
                                Swal.fire("¡Reactivado!", "Red Siebel Telco registrado", "success");
                                triggerGlobalRefresh();
                                setShowSiebelModal(false);
                                setList(prev => prev.map(s => s.SolicitudId === selected.SolicitudId
                                    ? { ...s, red_siebel_telcom: payload.red_siebel_telcom }
                                    : s
                                ));
                            } else {
                                Swal.fire("Error", data.result?.error_msg || "No se pudo reactivar", "error");
                            }
                        }}>Guardar</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showUserRedModal} onHide={() => setShowUserRedModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>INGRESAR FGU USUARIO RED</Modal.Title></Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>REACTIVACIÓN FGU USUARIO RED</Form.Label>
                            <Form.Control
                                type="text"
                                value={userRedValue}
                                onChange={e => setUserRedValue(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowUserRedModal(false)}>Cancelar</Button>
                        <Button variant="primary" onClick={async () => {
                            if (!userRedValue.trim()) {
                                Swal.fire("Error", "Debes ingresar el valor de Red Siebel Telco", "warning");
                                return;
                            }
                            const payload = { SolicitudId: selected.SolicitudId, usuario_red: userRedValue.trim() };
                            const res = await fetch(`${API_BASE}/solicitudes.php`, {
                                method: "PUT",
                                headers,
                                body: JSON.stringify(payload),
                            });
                            const data = await res.json();
                            if (data.status === "success" || data.status === "ok") {
                                Swal.fire("¡Reactivado!", "Usuario de Red registrado", "success");
                                triggerGlobalRefresh();
                                setShowUserRedModal(false);
                                setList(prev => prev.map(s => s.SolicitudId === selected.SolicitudId
                                    ? { ...s, usuario_red: payload.usuario_red }
                                    : s
                                ));
                            } else {
                                Swal.fire("Error", data.result?.error_msg || "No se pudo reactivar", "error");
                            }
                        }}>Guardar</Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showToaModal}
                    onHide={() => setShowToaModal(false)}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>INGRESAR FGU TOA</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>REACTIVAR FGU TOA</Form.Label>
                            <Form.Control
                                type="text"
                                value={toaValue}
                                onChange={e => setToaValue(e.target.value)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowToaModal(false)}>
                            Cancelar
                        </Button>
                        <Button
                            variant="primary"
                            onClick={async () => {
                                if (!toaValue.trim()) {
                                    return Swal.fire("Error", "Debes ingresar un valor", "warning");
                                }
                                const payload = {
                                    SolicitudId: selected.SolicitudId,
                                    fgu_toa: toaValue.trim(),
                                };

                                const res = await fetch(`${API_BASE}/solicitudes.php`, {
                                    method: "PUT",
                                    headers,
                                    body: JSON.stringify(payload),
                                });
                                const data = await res.json();

                                if (data.status === "success" || data.status === "ok") {
                                    Swal.fire("¡LISTO!", "FGU TOA Reactivado", "success");
                                    triggerGlobalRefresh();
                                    setShowToaModal(false);
                                    setList(prev => prev.map(s => s.SolicitudId === selected.SolicitudId
                                        ? { ...s, fgu_toa: payload.fgu_toa }
                                        : s
                                    ));
                                } else {
                                    Swal.fire("Error", data.result?.error_msg || "No se pudo reactivar", "error");
                                }
                            }}
                        >
                            Guardar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Detalle */}
                <Modal
                  show={showDetailModal}
                  onHide={() => setShowDetailModal(false)}
                  size="lg"
                  centered
                  dialogClassName="modal-100w"
                  style={{ zIndex: 11000 }}
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Detalle Solicitud</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {selected && (
                      <>
                        {/* Avatar centrado */}
                        <AvatarCentrado src={selected?.foto_url} alt="Foto del vendedor" />

                        {/* 1) Distribuidor */}
                        <InformacionUsuario
                          user={selected}
                          title="Distribuidor"
                          cols={2}
                          fields={[
                            { key: "distribuidor_nombre", label: "Distribuidor" },
                            { key: "distribuidor_rs", label: "Razón Social" },
                          ]}
                        />

                        {/* 3) Datos del usuario */}
                        <InformacionUsuario
                          user={selected}
                          title="Datos del usuario"
                          cols={3}
                          fields={[
                            { key: "usuario", label: "Email", render: (u) => u?.usuario || u?.Usuario || "—" },
                            {
                              key: "nombre_completo",
                              label: "Nombre completo",
                              render: (u) =>
                                [u?.nombre_usuario, u?.apellido_paterno, u?.apellido_materno]
                                  .filter(Boolean)
                                  .join(" "),
                            },
                            { key: "telefono", label: "Teléfono" },
                            { key: "Fecha", label: "Fecha Ingreso", render: (u) => u?.Fecha ? new Date(u.Fecha).toLocaleDateString("es-MX") : "—" },
                            { key: "rfc", label: "RFC", render: (u) => (u?.rfc || "—").toUpperCase() },
                            { key: "numero_vendedor", label: "Número Empleado" },
                          ]}
                        />

                        {/* 4) Puesto y credenciales */}
                        <InformacionUsuario
                          user={selected}
                          title="Puesto y credenciales"
                          cols={3}
                          hideEmpty={false}
                          fields={[
                            { key: "rol_id", label: "Puesto Actual", render: (u) => u?.tipo_usuario || "—" },
                            { key: "supervisor", label: "Supervisor Interno IZZI" },
                            { key: "usuario_red", label: "Usuario red", render: (u) => (u?.usuario_red || "—").toUpperCase() },
                            { key: "cvven", label: "CVVEN", render: (u) => u?.cvven || u?.ccven || "—" },
                          ]}
                        />

                        {/* 5) Ubicación */}
                        <InformacionUsuario
                          user={selected}
                          title="Ubicación"
                          cols={3}
                          fields={[
                            { key: "region_hub", label: "HUB" },
                            { key: "region_nombre", label: "Región" },
                            { key: "region_plaza", label: "Plaza" },
                          ]}
                        />
                        
                        {/* Foto INE */}
                        <hr />
                        <FotoINE url={selected?.ine_url} />
                      </>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDetailModal(false)}
                    >
                      Cerrar
                    </Button>
                  </Modal.Footer>
                </Modal>
            </Container>
        </div>
    );
}
